import React from "react";
import { Subscribe } from "unstated";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Fluent UI
import { Stack, Text, DefaultPalette } from "@fluentui/react";
// Our Modules
import { store } from "../../stores/Main";
import { AppList, Section } from "../../components";

const AppsPage = ({ store }) => {
  const { apps } = store.state.loggedInUser;
  if (!apps) return null;

  const titleList = apps.map(app => app.category);
  const titles = titleList.filter(function(elem, pos) {
    return titleList.indexOf(elem) === pos;
  });

  const appList = titles.map(title => ({
    title: title,
    apps: apps.map(app => app.category === title && app)
  }));

  return (
    <Section hero returnLink text="Apps">
      {apps.length ? (
        appList.map(app => (
          <Stack key={app.title}>
            <Text variant="large">{app.title}</Text>
            <AppList apps={app.apps} />
          </Stack>
        ))
      ) : (
        <Stack
          horizontalAlign="center"
          verticalAlign="center"
          styles={{
            root: {
              minHeight: 100,
              backgroundColor: DefaultPalette.white
            }
          }}
        >
          <Text>{i18n._(t`You currently have no apps assigned`)}</Text>
        </Stack>
      )}
    </Section>
  );
};

const StoreWrapper = props => (
  <Subscribe to={[store]}>
    {store => <AppsPage {...props} store={store} />}
  </Subscribe>
);

export default StoreWrapper;
